import { Link } from 'react-router-dom';
import { LOGO } from '../../content/media';

type LogoProps = {
  to?: string;
  className?: string;
};

export default function Logo({ to = '/', className = '' }: LogoProps) {
  const img = (
    <img
      src={LOGO}
      alt="SunStone Systems Limited"
      className={`h-12 lg:h-14 w-auto object-contain object-left ${className}`}
    />
  );

  if (!to) return img;

  return (
    <Link to={to} className="flex-shrink-0" aria-label="SunStone Systems Limited">
      {img}
    </Link>
  );
}
